import { render } from "./BlogList.vue?vue&type=template&id=13ab03a2"
import script from "./BlogList.vue?vue&type=script&lang=js"
export * from "./BlogList.vue?vue&type=script&lang=js"

import "./BlogList.vue?vue&type=style&index=0&id=13ab03a2&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__